function _typeof(o) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (o) {
        return typeof o;
    } : function (o) {
        return o && 'function' == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? 'symbol' : typeof o;
    }, _typeof(o);
}
function _classCallCheck(a, n) {
    if (!(a instanceof n))
        throw new TypeError('Cannot call a class as a function');
}
function _defineProperties(e, r) {
    for (var t = 0; t < r.length; t++) {
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, 'value' in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, 'prototype', { writable: !1 }), e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, 'string');
    return 'symbol' == _typeof(i) ? i : i + '';
}
function _toPrimitive(t, r) {
    if ('object' != _typeof(t) || !t)
        return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || 'default');
        if ('object' != _typeof(i))
            return i;
        throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return ('string' === r ? String : Number)(t);
}
var Subtitles = function () {
    function Subtitles(player) {
        var _this = this;
        _classCallCheck(this, Subtitles);
        this.player = player;
        this.player.template.mask.addEventListener('click', function () {
            _this.hide();
        });
        this.player.template.subtitlesButton.addEventListener('click', function () {
            _this.adaptiveHeight();
            _this.show();
        });
        var lastItemIndex = this.player.template.subtitlesItem.length - 1;
        var _loop = function _loop(i) {
            _this.player.template.subtitlesItem[i].addEventListener('click', function () {
                _this.hide();
                if (_this.player.options.subtitle.index !== i) {
                    _this.player.template.subtitle.innerHTML = '<p></p>';
                    _this.player.template.subtrack.src = _this.player.template.subtitlesItem[i].dataset.subtitle;
                    _this.player.options.subtitle.index = i;
                    if (_this.player.template.subtitle.classList.contains('dplayer-subtitle-hide')) {
                        _this.subContainerShow();
                    }
                }
            });
        };
        for (var i = 0; i < lastItemIndex; i++) {
            _loop(i);
        }
        this.player.template.subtitlesItem[lastItemIndex].addEventListener('click', function () {
            _this.hide();
            if (_this.player.options.subtitle.index !== lastItemIndex) {
                _this.player.template.subtitle.innerHTML = '<p></p>';
                _this.player.template.subtrack.src = '';
                _this.player.options.subtitle.index = lastItemIndex;
                _this.subContainerHide();
            }
        });
    }
    return _createClass(Subtitles, [
        {
            key: 'subContainerShow',
            value: function subContainerShow() {
                this.player.template.subtitle.classList.remove('dplayer-subtitle-hide');
                this.player.events.trigger('subtitle_show');
            }
        },
        {
            key: 'subContainerHide',
            value: function subContainerHide() {
                this.player.template.subtitle.classList.add('dplayer-subtitle-hide');
                this.player.events.trigger('subtitle_hide');
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.player.template.subtitlesBox.classList.remove('dplayer-subtitles-box-open');
                this.player.template.mask.classList.remove('dplayer-mask-show');
                this.player.controller.disableAutoHide = false;
            }
        },
        {
            key: 'show',
            value: function show() {
                this.player.template.subtitlesBox.classList.add('dplayer-subtitles-box-open');
                this.player.template.mask.classList.add('dplayer-mask-show');
                this.player.controller.disableAutoHide = true;
            }
        },
        {
            key: 'adaptiveHeight',
            value: function adaptiveHeight() {
                var curBoxHeight = this.player.template.subtitlesItem.length * 30 + 14;
                var stdMaxHeight = this.player.template.videoWrap.offsetHeight * 0.8;
                if (curBoxHeight >= stdMaxHeight - 50) {
                    this.player.template.subtitlesBox.style.bottom = '8px';
                    this.player.template.subtitlesBox.style['max-height'] = stdMaxHeight - 8 + 'px';
                } else {
                    this.player.template.subtitlesBox.style.bottom = '50px';
                    this.player.template.subtitlesBox.style['max-height'] = stdMaxHeight - 50 + 'px';
                }
            }
        }
    ]);
}();
export default Subtitles;